import React from 'react';
import { WebsiteDesignProps } from './types';
import { Ruler, Combine, DraftingCompass } from 'lucide-react';
import { Button } from "@/components/ui/button";

const EngineeringTech: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Polytechnic Institute";

    return (
        <div className="bg-[#f0f2f5] min-h-screen font-mono text-slate-800">
            {/* Grid Overlay */}
            <div className="fixed inset-0 pointer-events-none opacity-20" style={{
                backgroundImage: 'linear-gradient(#cbd5e1 1px, transparent 1px), linear-gradient(90deg, #cbd5e1 1px, transparent 1px)',
                backgroundSize: '20px 20px'
            }}></div>

            <nav className="bg-white border-b border-slate-300 p-4 sticky top-0 z-50">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="flex items-center gap-2 font-bold text-lg uppercase">
                        <div className="w-8 h-8 bg-blue-600 text-white flex items-center justify-center rounded">
                            <DraftingCompass size={18} />
                        </div>
                        {schoolName}
                    </div>
                    <div className="flex gap-6 text-sm font-bold text-slate-500 uppercase">
                         <a href="#" className="hover:text-blue-600">Departments</a>
                         <a href="#" className="hover:text-blue-600">Labs</a>
                         <a href="#" className="hover:text-blue-600">Industry</a>
                    </div>
                    <Button variant="outline" className="text-xs uppercase font-bold border-slate-400">
                        Login
                    </Button>
                </div>
            </nav>

            <main className="container mx-auto px-4 py-16 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
                    <div className="col-span-12 md:col-span-8 bg-white border border-slate-300 p-8 shadow-sm">
                        <div className="text-xs font-bold text-slate-400 uppercase mb-4 tracking-widest">
                            Project: Future_Builders
                        </div>
                        <h1 className="text-4xl md:text-6xl font-bold mb-6 text-slate-900 tracking-tighter">
                            Designed to Solve. <br/> Built to Last.
                        </h1>
                        <p className="text-lg text-slate-600 mb-8 max-w-2xl">
                            We equip students with theoretical knowledge and practical skills to tackle the world's most complex engineering challenges.
                        </p>
                        <div className="h-px bg-slate-200 w-full mb-8"></div>
                        <div className="flex gap-4">
                            <Button className="bg-blue-600 text-white rounded-none uppercase font-bold text-xs tracking-wider px-6 h-12">
                                Mechanical
                            </Button>
                            <Button className="bg-slate-800 text-white rounded-none uppercase font-bold text-xs tracking-wider px-6 h-12">
                                Electrical
                            </Button>
                            <Button className="bg-slate-200 text-slate-800 hover:bg-slate-300 rounded-none uppercase font-bold text-xs tracking-wider px-6 h-12">
                                Civil
                            </Button>
                        </div>
                    </div>

                    <div className="col-span-12 md:col-span-4 space-y-4">
                         <div className="bg-blue-600 text-white p-6 border border-blue-700">
                             <Ruler className="mb-4 text-blue-200" />
                             <h3 className="font-bold uppercase mb-2">Precision</h3>
                             <p className="text-sm text-blue-100">Accurate measurements and rigorous standards in all we do.</p>
                         </div>
                         <div className="bg-white p-6 border border-slate-300">
                             <Combine className="mb-4 text-slate-500" />
                             <h3 className="font-bold uppercase mb-2">Integration</h3>
                             <p className="text-sm text-slate-500">Combining disciplines for holistic solutions.</p>
                         </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default EngineeringTech;
